import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import { AuthContext } from "../../context/Auth/AuthContext";

import { Button, Divider } from "@material-ui/core";
import { isNil } from 'lodash';
import ShowTicketOpen from '../ShowTicketOpenModal';

const VcardPreview = ({ contact, numbers, queueId, whatsappId, channel }) => {
    const history = useHistory();
    const { user } = useContext(AuthContext);

    const companyId = user.companyId;

    const [openAlert, setOpenAlert] = useState(false);
    const [userTicketOpen, setUserTicketOpen] = useState("");
    const [queueTicketOpen, setQueueTicketOpen] = useState("");

    const [selectedContact, setContact] = useState({
        id: 0,
        name: "",
        number: 0,
        profilePicUrl: ""
    });

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async () => {
                try {
                    if (isNil(numbers)) {
                        return
                    }
                    const number = numbers.replace(/\D/g, "");
                    const profileParams = { channel };
                    if (whatsappId != null && whatsappId !== "" && whatsappId !== undefined) {
                        profileParams.whatsappId = whatsappId;
                    }
                    const getData = await api.get(`/contacts/profile/${number}`, { params: profileParams });

                    if (getData.data.contactId && getData.data.contactId !== 0) {
                        let obj = {
                            id: getData.data.contactId,
                            name: contact,
                            number: numbers,
                            urlPicture: getData.data.urlPicture
                        }

                        setContact(obj)
                    } else {
                        let contactObj = {
                            name: contact,
                            number: number,
                            email: "",
                            companyId: companyId
                        }

                        const { data } = await api.post("/contacts", contactObj);
                        setContact(data)
                    }

                } catch (err) {
                    console.log(err);
                    if (channel === "telegram") {
                        const fallbackNumber = String(numbers || "").replace(/\D/g, "");
                        setContact({
                            id: 0,
                            name: contact,
                            number: fallbackNumber,
                            urlPicture: ""
                        });
                        return;
                    }
                    toastError(err);
                }
            };
            fetchContacts();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [companyId, contact, numbers]);

    const handleCloseAlert = () => {
        setOpenAlert(false);
        setOpenAlert(false);
        setUserTicketOpen("");
        setQueueTicketOpen("");
    };

    const handleNewChat = async () => {
        try {
            const { data: ticket } = await api.post("/tickets", {
                contactId: selectedContact.id,
                userId: user.id,
                status: "open",
                queueId,
                companyId: companyId,
                whatsappId
            });

            if (ticket.reusedOpenTicket) {
                toast.info(i18n.t("showTicketOpenModal.reusedTicketToast"));
            }
            history.push(`/tickets/${ticket.uuid}`);
        } catch (err) {
            const status = err.response?.status;
            const data = err.response?.data;

            if (status === 403 && data?.ticket) {
                setOpenAlert(true);
                setUserTicketOpen(data.ticket?.user?.name || "");
                setQueueTicketOpen(data.ticket?.queue?.name || "");
                return;
            }

            if (status === 409 && data?.error) {
                try {
                    const existing = typeof data.error === "string" ? JSON.parse(data.error) : data.error;
                    if (existing?.userId !== user?.id) {
                        setOpenAlert(true);
                        setUserTicketOpen(existing?.user?.name);
                        setQueueTicketOpen(existing?.queue?.name);
                    } else if (existing?.uuid) {
                        history.push(`/tickets/${existing.uuid}`);
                    }
                } catch (_) {
                    toastError(err);
                }
                return;
            }

            toastError(err);
        }
    }

    return (
        <>
            <div style={{
                minWidth: "250px",
            }}>
                <ShowTicketOpen
                    isOpen={openAlert}
                    handleClose={handleCloseAlert}
                    user={userTicketOpen}
                    queue={queueTicketOpen}
                />
                <Grid container spacing={1}>
                    <Grid item xs={2}>
                        <Avatar src={`${selectedContact?.urlPicture}`} />
                    </Grid>
                    <Grid item xs={9}>
                        <Typography
                            style={{ marginTop: "12px", marginLeft: "10px" }}
                            color="primary"
                            variant="subtitle1"
                            gutterBottom
                        >
                            {selectedContact.name}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                        <Button
                            fullWidth
                            color="primary"
                            onClick={handleNewChat}
                            disabled={!selectedContact.number}
                        >Conversar</Button>
                    </Grid>
                </Grid>
            </div>
        </>
    );

};

export default VcardPreview;